import React from "react";
import { observer } from "mobx-react";
import Chip from "@material-ui/core/Chip";
import Tooltip from "@material-ui/core/Tooltip";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { ledgerStatusName, summarizeLedgerGroup } from "../../helper/superLedgerStatusSummary";

const colors = {
    Pending: ["#F5F5F5", "#616161"],
    Processing: ["#E3F2FD", "#1565C0"],
    Posted: ["#E3F2FD", "#1565C0"],
    Refunded: ["#FFF3E0", "#E65100"],
    Failed: ["#FFEBEE", "#C62828"],
    Unknown: ["#F5F5F5", "#616161"],
    "Partially Paid": ["#FFF3E0", "#E65100"]
};
const order = ["Failed", "Refunded", "Pending", "Processing", "Posted", "Unknown"];

function StatusBadge({ name, count }) {
    const [backgroundColor, color] = colors[name] || colors.Unknown;
    return <Chip
        label={count == null ? name : `${name} (${count})`}
        style={{ backgroundColor, color, fontWeight: 700, fontSize: 11, height: 22 }}
    />;
}

function PaidCheck() {
    return <Tooltip title="Paid — all contributions paid">
        <CheckCircleIcon titleAccess="Paid" style={{ color: "#4CAF50" }} />
    </Tooltip>;
}

function SuperLedgerPaymentStatus({ status, group }) {
    if (group === undefined) {
        const name = ledgerStatusName(status);
        if (name === "Paid") return <PaidCheck />;
        if (name === "Failed" || name === "Refunded") {
            return <Tooltip title={`A previous payment ${name === "Failed" ? "attempt failed" : "was refunded"}. You can retry.`}>
                <span><StatusBadge name={name} /></span>
            </Tooltip>;
        }
        return name === "Unknown" ? "Unknown status" : name;
    }

    const summary = summarizeLedgerGroup(group);
    if (summary.fullyPaid) return <PaidCheck />;
    const names = Object.keys(summary.counts);
    if (!names.length) return "Status unavailable";
    return <div style={{ display: "flex", gap: 4, flexWrap: "wrap", alignItems: "center" }}>
        {summary.reportedOnly && <span style={{ fontSize: 12 }}>Reported status — details unavailable:</span>}
        {summary.counts.Paid !== undefined && (
            summary.reportedOnly
                ? <span style={{ fontSize: 12 }}>Paid reported (unverified)</span>
                : <Chip
                    label={`Partially Paid — ${summary.paid} of ${summary.total} paid`}
                    style={{ backgroundColor: "#FFF3E0", color: "#E65100", fontWeight: 700, fontSize: 11, height: 22 }}
                />
        )}
        {order.filter(name => summary.counts[name] !== undefined).map(name =>
            <StatusBadge key={name} name={name} count={summary.counts[name]} />
        )}
    </div>;
}

export default observer(SuperLedgerPaymentStatus);
